module.exports = __webpack_public_path__ + "img/bitbucket.0d66ad5.png";